import {
  calculateDaysSinceUpdate,
  type DaysSinceUpdateResult,
} from "@/utils/calculate-days-since-update";
import { parseDaysSinceUpdate } from "@/utils/parse-days-since-update";

type CardUpdateInfo = {
  origin?: string | null;
  days_since_update?: string | null;
  updated_at?: string;
};

const isIntegrationOrigin = (
  card: CardUpdateInfo | null | undefined,
): boolean => card?.origin === "integration";

export const hasCardUpdateInfo = (
  card: CardUpdateInfo | null | undefined,
): boolean =>
  Boolean(
    card?.updated_at || card?.days_since_update || isIntegrationOrigin(card),
  );

export const getCardDisplayDays = (
  card: CardUpdateInfo | null | undefined,
): number | undefined => {
  if (isIntegrationOrigin(card)) return 0;
  return parseDaysSinceUpdate(card?.days_since_update) ?? undefined;
};

export const getCardUpdateDisplay = (
  card: CardUpdateInfo | null | undefined,
  prefix?: string,
): DaysSinceUpdateResult =>
  calculateDaysSinceUpdate({
    date: card?.updated_at,
    prefix,
    daysSinceUpdate: card?.days_since_update,
    treatAsToday: isIntegrationOrigin(card),
  });
